import { Reason, WorkflowRejectedStage } from 'api-clients/monolith';
import React, { VFC } from 'react';
import { useSelector } from 'react-redux';

import { makeUniversalRecruiterDashboardEnabled } from 'containers/Auth_old/selectors';
import { AdvancedSettings } from 'containers/WorkflowEditor/components/AdvancedSettings';
import { IdleMoveRule } from 'containers/WorkflowEditor/components/IdleMoveRule';
import { ReviewStage } from 'containers/WorkflowEditor/components/ReviewStage';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';
import { StageSettingMessageCard } from 'containers/WorkflowEditor/components/StageSettingMessageCard';
import { defaultReason } from 'containers/WorkflowEditor/components/StageSettingMessageCard/components/MessageRow/MessageRow.fixtures';
import { useRejectionReasons } from 'containers/WorkflowEditor/hooks/useRejectionReasons';

export interface RejectedStageProps {
  stage: WorkflowRejectedStage;
}

export const RejectedStage: VFC<RejectedStageProps> = ({ stage }) => {
  const { result: rejectedReasonResult } = useRejectionReasons();
  const universalRecruiterDashboardEnabled = useSelector(
    makeUniversalRecruiterDashboardEnabled(),
  );

  let reasons: Reason[] = [defaultReason];
  if (rejectedReasonResult.status === 'ready') {
    reasons = reasons.concat(rejectedReasonResult.data.rejection_reasons);
  }

  return (
    <div data-testid="rejectedStage">
      {universalRecruiterDashboardEnabled && (
        <StageSection>
          <ReviewStage stage={stage} />
        </StageSection>
      )}
      <StageSection>
        <IdleMoveRule stage={stage} />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="rejection"
          stageExternalId={stage.external_id}
          reasons={reasons}
        />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="trigger"
          stageExternalId={stage.external_id}
        />
      </StageSection>
      {stage.account_go_enabled && (
        <StageSection>
          <AdvancedSettings stage={stage} />
        </StageSection>
      )}
    </div>
  );
};
